import React, { useEffect } from 'react'
import { required, TextInput, TextInputProps } from 'react-admin'
import { COMMON_FIELDS } from '../../providers/localization/constant'
import { useFormContext, useWatch } from 'react-hook-form'

const defaultProps = {
  label: `${COMMON_FIELDS}.target_link.label`,
  source: 'target_link',
}

export const TextInputTargetValue: React.FC<TextInputProps> = ({ label, source, ...props }) => {
  const depField = 'action_type'
  const expectedValue = 'external_browser'

  const fieldCond = useWatch({ name: depField })
  const { unregister } = useFormContext()
  const validator = {
    validate: [required()],
  }

  useEffect(() => {
    if (fieldCond !== expectedValue) {
      unregister(source)
    }
  }, [fieldCond, source, unregister])
  if (!depField) return null

  return fieldCond === expectedValue ? (
    <TextInput
      source={source}
      label={label}
      InputProps={{
        fullWidth: true,
      }}
      fullWidth
      {...(fieldCond === expectedValue ? validator : '')}
      {...props}
    />
  ) : null
}

TextInputTargetValue.defaultProps = defaultProps
